import * as React from "react";
const SvgFiRrDiceD20 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dice-d20_svg__a)">
      <path
        fill="#062147"
        d="m20.573 4.312-6-3.6a4.99 4.99 0 0 0-5.146 0l-6 3.6A5.03 5.03 0 0 0 1 8.6v6.8a5.03 5.03 0 0 0 2.427 4.288l6 3.6a4.99 4.99 0 0 0 5.146 0l6-3.6A5.03 5.03 0 0 0 23 15.4V8.6a5.03 5.03 0 0 0-2.427-4.288M3.005 8.437l2.733 1.639L3 14.09s0-5.6.005-5.653m9-5.378 3.295 5.94H8.7zm9 10.918-2.73-3.905L21 8.437v5.54zM8.805 11H15.2L12 16.113zm-4.787 5.147 2.943-4.322 3.046 4.875zm13.029-4.334 3.027 4.332-6.074.538zm2.5-5.786q.374.225.668.548L17.233 8.36l-3.1-5.58zm-15.086 0L9.868 2.78 6.77 8.363 3.789 6.575a3 3 0 0 1 .668-.548zm.44 12.21L11 18.8v3.03a3 3 0 0 1-.543-.257zm8.646 3.335q-.259.156-.543.257v-3.05l6.1-.54z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dice-d20_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiceD20;
